<template>
  <div>
    <!-- 标题 -->
    <div class="storageGateway-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/storageGatewayMonitor">StorageGateway</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="getDetail">{{ $t('alarms.common.monitoringSummary') }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="storageGateway-top">
      <Row :gutter="16">
        <Col span="6">
          <Select v-model="timeType" @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
        <Col span="6" v-for="(item,index) in list" :key="index">
            <Card :padding="8">
                <p slot="title">{{item.title}}</p>
                <a href="#" slot="extra" @click.prevent="changeFull(item)">
                    <Icon type="ios-expand" size="18"/>
                </a>
                <div :id="item.id" :ref="item.id" style="width:100%;height: 240px;"></div>
            </Card>
        </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal v-model="isShowModal" :mask-closable="false" :closable="false" width="65%">
        <Row>
            <Col span="24">
                <h3>{{lineTitle}}</h3>
                <div id="chart-part" ref="fullChart" style="width:100%; height:420px;"></div>
            </Col>
        </Row>
        <div slot="footer">
            <div>
                <Button @click="cancel">{{$t('alarms.common.close')}}</Button>
            </div>
        </div>
    </Modal>  
  </div>
</template>

<script>
import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'

export default {
  name: 'Elasticsearch',
  data() {
    return {
      // 放大功能
      lineTitle:'',
      isShowModal: false,
      // aws折线图
      list: [{
          id: 'cachePercentUsed',
          title:this.$t('StorageGateway.line.cachePercentUsed')
      },
      {
          id: 'cacheHitPercent',
          title:this.$t('StorageGateway.line.cacheHitPercent')
      },
      {
          id: 'cachePercentDirty',
          title:this.$t('StorageGateway.line.cachePercentDirty')
      },
      {
          id: 'ioWaitPercent',
          title:this.$t('StorageGateway.line.ioWaitPercent')
      },
      {
          id: 'availabilityNotifications',
          title:this.$t('StorageGateway.line.availabilityNotifications')
      },
      {
          id: 'healthNotifications',
          title:this.$t('StorageGateway.line.healthNotifications')
      }],
      timeType: 0,
      timeList: [],
      id: '',
      accountId: '',
      accountTypeName: '',
      accountName: '',
      region: '',
      // echarts实例
      chartCachePercentUsed: '',
      chartCacheHitPercent: '',
      chartCachePercentDirty: '',
      chartIoWaitPercent: '',
      chartAvailabilityNotifications: '',
      chartHealthNotifications: '',
      cachePercentUsedOption:{},
      cacheHitPercentOption:{},
      cachePercentDirtyOption:{},
      ioWaitPercentOption:{},
      availabilityNotificationsOption:{},
      healthNotificationsOption:{},
      //AWS数组
      cachePercentUsed: [],
      cacheHitPercent: [],
      cachePercentDirty: [],
      ioWaitPercent: [],
      availabilityNotifications: [],
      healthNotifications: [],
      xaxisData: []
    }
  },
  mounted: function () {
    this.queryTimeHorizon();
    // 自适应不同屏幕尺寸
    const self = this;
    window.addEventListener("resize", function () {
      self.chartCachePercentUsed.resize();
      self.chartCacheHitPercent.resize();
      self.chartCachePercentDirty.resize();
      self.chartIoWaitPercent.resize();
      self.chartAvailabilityNotifications.resize();
      self.chartHealthNotifications.resize();
    });
  },
  created() {
    this.checkAWSStorageGatewayStatistics();
  },
  methods: {
    /******************放大********************************/
    changeFull:function(item){
        this.isShowModal=true;
        this.lineTitle=item.title;
        this.$nextTick(() => {
            const chartFul = this.$refs.fullChart;
            if(chartFul){
                const fullChart = this.$echarts.init(
                    document.getElementById("chart-part")
                );
                fullChart.clear();
                if(item.id=='cachePercentUsed'){
                    var optionFll = this.cachePercentUsedOption;
                }else if(item.id=='cacheHitPercent'){
                    var optionFll = this.cacheHitPercentOption;
                }else if(item.id=='cachePercentDirty'){
                    var optionFll = this.cachePercentDirtyOption;
                }else if(item.id=='ioWaitPercent'){
                    var optionFll = this.ioWaitPercentOption;
                }else if(item.id=='availabilityNotifications'){
                    var optionFll = this.availabilityNotificationsOption;
                }else if(item.id=='healthNotifications'){
                    var optionFll = this.healthNotificationsOption;
                }
                
                fullChart.setOption(optionFll);
                window.addEventListener("resize", function() {
                    fullChart.resize();
                });    
            }
        });
    },
    // 模态框取消事件
    cancel() {
        this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch.queryTimeHorizon("userName", getCookie(global.cookieName))
        .then(res => {
          this.timeList = res.data;
        })
    },
    // AWS Storage Gateway 折线图
    checkAWSStorageGatewayStatistics: function () {
      this.$api.cloudWatch.checkAWSStorageGatewayStatistics({
        "accountId": this.$route.query.accountId,
        "timeHorizon": this.timeType,
        "monitorModule": 35,
        "region": this.$route.query.region,
        "storageGatewayName": this.$route.query.name
      })
        .then(res => {
          this.xaxisData = res.data.xaxisData;
          this.cachePercentUsed = res.data.cachePercentUsed;
          this.cacheHitPercent = res.data.cacheHitPercent;
          this.cachePercentDirty = res.data.cachePercentDirty;
          this.ioWaitPercent = res.data.ioWaitPercent;
          this.availabilityNotifications = res.data.availabilityNotifications;
          this.healthNotifications = res.data.healthNotifications;
          this.allAws();
        })
    },
    changeTimeType: function () {
      this.checkAWSStorageGatewayStatistics();
    },
    /******************所有折线图********************************/
    allAws: function () {
      this.cachePercentUsedLine();
      this.cacheHitPercentLine();
      this.cachePercentDirtyLine();
      this.ioWaitPercentLine();
      this.availabilityNotificationsLine();
      this.healthNotificationsLine();
    },
    /*************折线图*****************************/
    // AWS Storage Gateway 缓存总使用率 单位 %（百分比）
    cachePercentUsedLine: function () {
      this.chartCachePercentUsed = this.$echarts.init(document.getElementById("cachePercentUsed"));
      this.cachePercentUsedOption={
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          x: 'right',
          y: '10px',
          data: [this.$t('StorageGateway.line.cachePercentUsed')]
        },
        series: [{
          name: this.$t('StorageGateway.line.cachePercentUsed'),
          type: 'line',
          data: this.cachePercentUsed,
          itemStyle: {
            normal: {
              color: "#61a0a8",
              lineStyle: {
                color: "#61a0a8"
              }
            }
          }
        }],
        grid: {
          top:'20%',
          left: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(' ', '\n')
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: 'value'
          }
        ]
      }
      this.chartCachePercentUsed.setOption(this.cachePercentUsedOption)
    },
    //AWS Storage Gateway 从缓存中提供的读取请求的百分比 单位 %
    cacheHitPercentLine: function () {
      this.chartCacheHitPercent = this.$echarts.init(document.getElementById("cacheHitPercent"));
      this.cacheHitPercentOption={
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          x: 'right',
          y: '10px',
          data: [this.$t('StorageGateway.line.cacheHitPercent')]
        },
        series: [{
          name: this.$t('StorageGateway.line.cacheHitPercent'),
          type: 'line',
          data: this.cacheHitPercent,
          itemStyle: {
            normal: {
              color: "#61a0a8",
              lineStyle: {
                color: "#61a0a8"
              }
            }
          }
        }],
        grid: {
          top:'20%',
          left: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(' ', '\n')
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 2,
            type: 'value'
          }
        ]
      }
      this.chartCacheHitPercent.setOption(this.cacheHitPercentOption)
    },
    //AWS Storage Gateway 缓存废数据百分比 单位 %
    cachePercentDirtyLine: function () {
      this.chartCachePercentDirty = this.$echarts.init(document.getElementById("cachePercentDirty"));
      this.cachePercentDirtyOption={
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          x: 'right',
          y: '10px',
          data: [this.$t('StorageGateway.line.cachePercentDirty')]
        },
        series: [{
          name: this.$t('StorageGateway.line.cachePercentDirty'),
          type: 'line',
          data: this.cachePercentDirty,
          itemStyle: {
            normal: {
              color: "#61a0a8",
              lineStyle: {
                color: "#61a0a8"
              }
            }
          }
        }],
        grid: {
          top:'20%',
          left: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(' ', '\n')
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: 'value'
          }
        ]
      }
      this.chartCachePercentDirty.setOption(this.cachePercentDirtyOption)
    },
    //AWS Storage Gateway 高 IO 等待 单位 %
    ioWaitPercentLine: function () {
      this.chartIoWaitPercent = this.$echarts.init(document.getElementById("ioWaitPercent"));
      this.ioWaitPercentOption={
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          x: 'right',
          y: '10px',
          data: [this.$t('StorageGateway.line.ioWaitPercent')]
        },
        series: [{
          name: this.$t('StorageGateway.line.ioWaitPercent'),
          type: 'line',
          data: this.ioWaitPercent,
          itemStyle: {
            normal: {
              color: "#61a0a8",
              lineStyle: {
                color: "#61a0a8"
              }
            }
          }
        }],
        grid: {
          top:'20%',
          left: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(' ', '\n')
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: 'value'
          }
        ]
      }
      this.chartIoWaitPercent.setOption(this.ioWaitPercentOption)
    },
    //AWS Storage Gateway 可用性通知
    availabilityNotificationsLine: function () {
      this.chartAvailabilityNotifications = this.$echarts.init(document.getElementById("availabilityNotifications"));
      this.availabilityNotificationsOption={
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          x: 'right',
          y: '10px',
          data: [this.$t('StorageGateway.line.availabilityNotifications')]
        },
        series: [{
          name: this.$t('StorageGateway.line.availabilityNotifications'),
          type: 'line',
          data: this.availabilityNotifications,
          itemStyle: {
            normal: {
              color: "#61a0a8",
              lineStyle: {
                color: "#61a0a8"
              }
            }
          }
        }],
        grid: {
          top:'20%',
          left: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(' ', '\n')
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 2,
            type: 'value'
          }
        ]
      }
      this.chartAvailabilityNotifications.setOption(this.availabilityNotificationsOption)
    },
    //AWS Storage Gateway 运行状况通知
    healthNotificationsLine: function () {
      this.chartHealthNotifications = this.$echarts.init(document.getElementById("healthNotifications"));
      this.healthNotificationsOption={
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          x: 'right',
          y: '10px',
          data: [this.$t('StorageGateway.line.healthNotifications')]
        },
        series: [{
          name: this.$t('StorageGateway.line.healthNotifications'),
          type: 'line',
          data: this.healthNotifications,
          itemStyle: {
            normal: {
              color: "#61a0a8",
              lineStyle: {
                color: "#61a0a8"
              }
            }
          }
        }],
        grid: {
          top:'20%',
          left: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(' ', '\n')
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 2,
            type: 'value'
          }
        ]
      }
      this.chartHealthNotifications.setOption(this.healthNotificationsOption)
    },
    /********************************/
    // 点击返回详情页
    getDetail: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.$router.push({
        path: '/monitor/storageGatewayDetail/',
        query: {
          id: this.id,
          accountId: this.accountId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    }
  }
}
</script>

<style scoped>
.storageGateway-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}

.ivu-col-span-6 {
  margin-bottom: 20px;
}

.storageGateway-top {
  width: 100%;
  height: 53px;
}

.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/storage_gateway/storagegateway_dashboard/StorageGateway.vue